import styled from 'styled-components/macro'

/** Pagination size variant. `md` (default) is the original 40px row; `sm` is a
 *  compact 32px / 12px-font row for dense tables. */
export type PaginationSize = 'sm' | 'md'

export const DataTablePaginationContainer = styled.div<{
  $size?: PaginationSize
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ $size }) => ($size === 'sm' ? '8px 24px' : '16px 24px')};
`

export const PageButton = styled.button<{
  isActive: boolean
  $size?: PaginationSize
}>`
  border: none;

  /* DS2026 pagination button — neutral light bg on active/hover, no green.
     Width hugs content for long page numbers (e.g. 10,445) while keeping a
     square minimum hit-area (40×40 md / 32×32 sm) for single/double digits. */
  min-width: ${({ $size }) => ($size === 'sm' ? '32px' : '40px')};
  height: ${({ $size }) => ($size === 'sm' ? '32px' : '40px')};
  padding: ${({ $size }) => ($size === 'sm' ? '0 8px' : '0 10px')};

  background-color: ${({ isActive }) => (isActive ? '#F3F4F6' : 'transparent')};
  border-radius: ${({ $size }) => ($size === 'sm' ? '6px' : '8px')};

  font-style: normal;
  font-weight: ${({ isActive }) => (isActive ? 600 : 500)};
  font-size: ${({ $size }) => ($size === 'sm' ? '12px' : '14px')};
  line-height: ${({ $size }) => ($size === 'sm' ? '16px' : '20px')};
  font-variant-numeric: tabular-nums;

  /* neutral-900 on active/hover, neutral-700 default (see design-tokens.cjs) */
  color: ${({ isActive }) => (isActive ? '#111827' : '#374151')};

  &:hover {
    background-color: #f3f4f6;
    color: #111827;
  }
`

export const DataTablePaginationDots = styled.div`
  margin: 0 0.5rem;
  width: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: default;
`

export const DataTablePaginationButtonsContainer = styled.div`
  display: flex;
  gap: 5px;
  margin: 0px 8px 0px 8px;
`
